import { RouteComponentProps } from "@reach/router";
import Layout from "../layout/Layout";
import { EntityNames } from "../../../enums/EntityNames";
import RecallsPackList from "../List/RecallsPackList";

export default function RecallsPackingPage(props: RouteComponentProps) {
    return (
        <Layout entityName={EntityNames.pickList} pageTitle={`Pack List`} data={{}} showBackButton={true} showBreadcrumb={false} canScroll={true}>
            <RecallsPackList />
        </Layout>
    )
}